import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <SectionHeading eyebrow="About RelayRigs" title="Building a More Flexible Transportation Network" align="center" testId="about" />
        <Reveal delay={0.2}>
          <p className="mt-6 text-rr-muted text-base md:text-lg leading-relaxed">
            RelayRigs is being developed to make it easier for qualified drivers, equipment owners, carriers, and authorized vehicle owners to connect when transportation needs another driver. The platform combines marketplace matching with operational tools for qualification, payments, HOS awareness, navigation, handoffs, tracking, insurance workflows, documentation, and delivery verification.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
